export const stripParentheses = (string: string): string => {
  return string.replace(/\(.*?\)/g, '').trim()
}
